export default __webpack_public_path__ + "static/media/Inter-UI-Thin-BETA.edb55c47.woff";